<template>
  <div class="wh-container">
    <home-nav-bar class="top-nav-bar" :border="false" title="历史种养品种">
      <template #left>
        <router-link :to="{name: 'PlotDetail', query: {landId: landId}}">
          <van-icon name="arrow-left" />
        </router-link>
      </template>
    </home-nav-bar>
    <wh-mobile-list ref="cropBreedHistoryList" class="list" :extra-params="extraParams" data-src="/api/getCropBreedHistory">
      <template v-slot="{list}">
        <van-row v-for="(cropBreedItem, key) in list" :key="key" class="crop-breed-item">
          <van-col span="8">
            <van-image
              width="80px"
              height="80px"
              class="crop-image"
              fit="cover"
              :src="cropBreedItem.cropPic"
            />
          </van-col>
          <van-col class="right-content" span="16">
            <div class="head wh-flex-between">
              <div>
                <div class="name">
                  {{ cropBreedItem.cropBreed }}
                </div>
                <van-tag class="count" type="primary">
                  {{ cropBreedItem.plantNum }} {{ cropBreedItem.cropUnit }}
                </van-tag>
              </div>
              <div class="plant-method">
                {{ cropBreedItem.plantMethod }}
              </div>
            </div>
            <div class="wh-flex-between bottom">
              <van-tag size="large" class="plant-standard" type="success">
                {{ cropBreedItem.plantStandard }}
              </van-tag><span class="time">{{ formatTime(cropBreedItem.plantStartDate, 'YYYY-MM-DD') }}</span>
            </div>
          </van-col>
        </van-row>
      </template>
    </wh-mobile-list>
  </div>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import { formatTime } from '@/utils/convert/convertTime'

export default {
  name: 'CropBreedHistory',
  components: { HomeNavBar, WhMobileList },
  props: {
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
    }
  },
  computed: {
    extraParams() {
      const companyId = Number(this.$route.query.companyId)
      return {
        landId: this.landId,
        companyId: Number.isNaN(companyId) ? undefined : companyId
      }
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>

.crop-breed-item  {
  margin: 20px 20px 0 20px;
  padding: 10px 12px 6px;
  background: #ffffff;
  border-radius: 6px;
  .divider {
    margin: 6px 0 0 0 ;
  }
  .right-content {
    padding-top: 10px;
    .head {
      .plant-method {
        white-space: nowrap;
        font-size: 14px;
        letter-spacing: 0.1em;
      }
    }
    .bottom {
      margin-top: 16px;
      align-items: flex-end;
      .time {
        font-size: 14px;
        color: #787878;
      }
    }
  }
  .options {
    text-align: right;
    .btn {
      border: none;
    }
  }
}
</style>
